import ArticleLink from '@/components/feature/ArticleLink';
import { useLearningProgress } from '@/hooks/useLearningProgress';

export default function HomeProgressStrip() {
  const { readCount, total, percent, nextArticle, isComplete } = useLearningProgress();

  // Only returning readers (who already have progress) see this slim strip.
  if (readCount === 0) return null;

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 pb-12 md:px-6 md:pb-14 lg:px-10">
        <div className="flex flex-col gap-4 rounded-2xl border border-background-200 bg-background-100/60 p-5 sm:flex-row sm:items-center sm:gap-6 md:p-6">
          <span
            className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${
              isComplete ? 'bg-accent-100 text-accent-700' : 'bg-primary-100 text-primary-600'
            }`}
          >
            <i className={`${isComplete ? 'ri-trophy-line' : 'ri-route-line'} text-xl`} />
          </span>

          <div className="min-w-0 sm:flex-1">
            <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
              <p className="font-heading text-sm font-semibold text-foreground-950">
                {isComplete ? 'คุณเรียนครบทั้ง 30 หัวข้อแล้ว' : 'ความคืบหน้าการเรียนของคุณ'}
              </p>
              <span className="font-num text-xs font-semibold text-primary-700">
                เรียนไปแล้ว {readCount}/{total} หัวข้อ · {percent}%
              </span>
            </div>
            <div className="mt-2.5 h-2 w-full overflow-hidden rounded-full bg-background-200">
              <div
                className={`h-full rounded-full transition-[width] duration-500 ease-out ${
                  isComplete ? 'bg-accent-500' : 'bg-primary-500'
                }`}
                style={{ width: `${percent}%` }}
              />
            </div>
          </div>

          {nextArticle ? (
            <ArticleLink
              to={nextArticle.to}
              className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-line text-base" />
              อ่านต่อ
              <span className="hidden max-w-[170px] truncate font-normal text-background-50/90 xl:inline">
                · {nextArticle.label}
              </span>
            </ArticleLink>
          ) : (
            <ArticleLink
              to="/forex-trading"
              className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-arrow-right-line text-base" />
              ไปที่วิธีเทรด Forex
            </ArticleLink>
          )}
        </div>
      </div>
    </section>
  );
}